import { CREATE_REPEATER_SOURCE as type } from './';

export default (sourceName, repeaterKey) => ({
  type,
  payload: { sourceName, repeaterKey },
});
